import { action } from 'satcheljs';

/**
 * Signal for moving focus to the new-event button
 */
export const focusNewEventButton = action('focusNewEventButton');
